import React, { useEffect, useRef, useState } from 'react'
import styles from './OrderByDropdown.module.sass'
import useTrans from '@hooks/useTrans'
import { Check, ChevronDown } from '@components/icons'


interface Props {
  ordinamenti?: any
  orderBy?: any
  setOrderBy?: (v: any) => void
  className?: string
}

const OrderByDropdown = (props: Props) => {

  const { 
    ordinamenti = [],
    orderBy = undefined,
    setOrderBy = undefined,
    className = '',
  } = props

  const t = useTrans()
  const ref = useRef(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!!ref?.current && !ref?.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document?.removeEventListener('mousedown', handleOutsideClick)
  }, [])

  return ordinamenti.length > 0 ? (
    <div className={`${styles.root} ${open ? styles['root--open'] : ''} ${className}`} ref={ref}>
      <button type="button" className={styles.trigger} onClick={() => setOpen((prev) => !prev)}>
        <div>
          {t(`Ordina per: `)}
          <span>{ordinamenti.find((x) => x.value === orderBy)?.label}</span>
        </div>
        <ChevronDown className={styles.icon} />
      </button>
      <div className={styles.dropdown}>
        {ordinamenti.map((item) => (
          <button
            onClick={() => {
              setOrderBy(item.value)
              setOpen(false)
            }}
            className={`${styles.value} ${item.value === orderBy ? styles['value--active'] : ''}`}
            key={item.value}
          >
            <span>{item?.label}</span>
            {item.value === orderBy && <Check />}
          </button>
        ))}
    </div>
    </div>
  ) : <></>
}

export default OrderByDropdown
